import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PatentView, getPatentOptions } from '@/module/Author/Patent';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/$patentId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { patentId } = Route.useParams();
  const { data: patent } = useSuspenseQuery(getPatentOptions(patentId));

  return <PatentView patent={patent} />;
}
